import { useWhiteLabelAppDetails } from '@src/queries/org'
import { getOrgTheme } from '@styles/themes'

export const useOrgTheme = () => {
  const { data: appInfo } = useWhiteLabelAppDetails()
  return getOrgTheme(appInfo?.identifier)
}
